<template>
  <div id="contenedor-estadistica-por-porgrama">
    <v-simple-table>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th>Programa</th>
            <th>Tipo</th>
            <th>Subtipo</th>
            <th align="center">Contratos</th>
            <th>Contratado</th>
            <th>Facturado</th>
            <th>Solicitado</th>
            <th>Pagado</th>
            <th align="center">Av. Programado</th>
            <th align="center">Av. Fisico</th>
            <th align="center">Av. Financiero</th>
            <th>Cont. A/IVA</th>
            <th>Estimado</th>
            <th>Por Estimar</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(dato, index) in datos">
            <template>
              <tr
                :key="`programa-${index}`"
                class="font-weight-bold grey lighten-2">
                <td>
                  {{ dato.descripcion }}
                </td>
                <td></td>
                <td></td>
                <td align="center">
                  <v-chip
                    @click="mostrarContratos(dato.contratos, dato.descripcion)">
                    {{ dato.cantidadContratos }}
                  </v-chip>
                </td>
                <td align="right">
                  {{ dato.totalContratado | currency }}
                </td>
                <td align="right">
                  {{ dato.totalFacturado | currency }}
                </td>
                <td align="right">
                  {{ dato.montoSolicitado | currency }}
                </td>
                <td align="right">
                  {{ dato.montoPagado | currency }}
                </td>
                <td align="center">
                  <v-chip
                    color="naranja2">
                    {{ $numberRound((dato.avanceProgramado * 100)) }}%
                  </v-chip>
                </td>
                <td align="center">
                  <v-chip
                    color="azul1">
                    {{ $numberRound((dato.avanceFisico * 100)) }}%
                  </v-chip>
                </td>
                <td align="center">
                  <v-chip
                    color="verde1">
                    {{ $numberRound((dato.avanceFinanciero * 100)) }}%
                  </v-chip>
                </td>
                <td align="right">
                  {{ dato.importeTotal | currency }}
                </td>
                <td align="right">
                  {{ dato.importeEstimado | currency }}
                </td>
                <td align="right">
                  {{ dato.importePorEstimar | currency }}
                </td>
              </tr>
            </template>
            <template
              v-for="(tipo) in dato.tipos">
              <template>
                <tr
                  :key="`tipo-${tipo.descripcion}-${tipo.cantidadContratos}-${dato.descripcion}`"
                  class="font-weight-medium grey lighten-4">
                  <td></td>
                  <td>
                    {{ tipo.descripcion }}
                  </td>
                  <td></td>
                  <td align="center">
                    <v-chip
                      @click="mostrarContratos(tipo.contratos,
                        `${dato.descripcion} [${tipo.descripcion}]`)">
                      {{ tipo.cantidadContratos }}
                    </v-chip>
                  </td>
                  <td align="right">
                    {{ tipo.totalContratado | currency }}
                  </td>
                  <td align="right">
                    {{ tipo.totalFacturado | currency }}
                  </td>
                  <td align="right">
                    {{ tipo.totalSolicitado | currency }}
                  </td>
                  <td align="right">
                    {{ tipo.totalPagado | currency }}
                  </td>
                  <td align="center">
                    <v-chip
                      color="naranja2">
                      {{ $numberRound((tipo.avanceProgramado * 100)) }}%
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip
                      color="azul1">
                      {{ $numberRound((tipo.avanceFisico * 100)) }}%
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip
                      color="verde1">
                      {{ $numberRound((tipo.avanceFinanciero * 100)) }}%
                    </v-chip>
                  </td>
                  <td align="right">
                    {{ tipo.importeTotal | currency }}
                  </td>
                  <td align="right">
                    {{ tipo.importeEstimado | currency }}
                  </td>
                  <td align="right">
                    {{ tipo.importePorEstimar | currency }}
                  </td>
                </tr>
              </template>
              <template
                v-for="(subtipo) in tipo.subtipos">
                <template>
                  <tr
                    :key="`subtipo-${subtipo.descripcion}-${subtipo.totalContratado}`">
                    <td></td>
                    <td></td>
                    <td>
                      {{ subtipo.descripcion }}
                    </td>
                    <td align="center">
                      <v-chip
                        @click="mostrarContratos(subtipo.contratos,
                          `${dato.descripcion} [${subtipo.descripcion}]`)">
                        {{ subtipo.cantidadContratos }}
                      </v-chip>
                    </td>
                    <td align="right">
                      {{ subtipo.totalContratado | currency }}
                    </td>
                    <td align="right">
                      {{ subtipo.totalFacturado | currency }}
                    </td>
                    <td align="right">
                      {{ subtipo.montoSolicitado | currency }}
                    </td>
                    <td align="right">
                      {{ subtipo.montoPagado | currency }}
                    </td>
                    <td align="center">
                      <v-chip
                        color="naranja2">
                        {{ $numberRound((subtipo.avanceProgramado * 100)) }}%
                      </v-chip>
                    </td>
                    <td align="center">
                      <v-chip
                        color="azul1">
                        {{ $numberRound((subtipo.avanceFisico * 100)) }}%
                      </v-chip>
                    </td>
                    <td align="center">
                      <v-chip
                        color="verde1">
                        {{ $numberRound((subtipo.avanceFinanciero * 100)) }}%
                      </v-chip>
                    </td>
                    <td align="right">
                      {{ subtipo.importeTotal | currency }}
                    </td>
                    <td align="right">
                      {{ subtipo.importeEstimado | currency }}
                    </td>
                    <td align="right">
                      {{ subtipo.importePorEstimar | currency }}
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </tbody>
        <tfoot
          class="font-weight-bold selected">
          <tr>
            <td colspan="3">TOTAL</td>
            <td align="center">
              <v-chip>
                {{ $ObjSumar(datos, 'cantidadContratos') }}
              </v-chip>
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'totalContratado') | currency }}
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'totalFacturado') | currency }}
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'montoSolicitado') | currency }}
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'montoPagado') | currency }}
            </td>
            <td align="center">
              <v-chip
                color="naranja2">
                {{ $numberRound(avances.programado * 100) }}%
              </v-chip>
            </td>
            <td align="center">
              <v-chip
                color="azul1">
                {{ $numberRound(avances.fisico * 100) }}%
              </v-chip>
            </td>
            <td align="center">
              <v-chip
                color="verde1">
                {{ $numberRound(avances.financiero * 100) }}%
              </v-chip>
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'importeTotal') | currency }}
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'importeEstimado') | currency }}
            </td>
            <td align="right">
              {{ $ObjSumar(datos, 'importePorEstimar') | currency }}
            </td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'tablaPrograma',
  props: {
    datos: {
      type: Array,
    },
    avances: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    mostrarContratos(contratos, titulo) {
      this.$emit('mostrar-detalles-tabla', contratos, titulo);
    },
  },
};
</script>

<style lang="scss">

</style>
